import { useCallback as o } from "react";
import { getCopilotFileDownloadUrl as n, getCopilotFilesDownloadUrls as e } from "../file-download.js";
function w(l) {
  const r = o(
    async (t) => l == null ? "" : await n(l, t),
    [l]
  ), a = o(
    async (t) => l == null ? [] : await e(l, t),
    [l]
  );
  return {
    getFileDownloadUrl: r,
    getFilesDownloadUrls: a
  };
}
export {
  w as useCopilotFileDownload
};
